import Route from '@ember/routing/route';

import { set } from '@ember/object';

/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      route — user account page: collapses chrome and kicks the
 *              controller's data load task on entry, cancels it on leave.
 *   extends:   Route (@ember/routing/route)
 *   template:  none
 *   model:     - (no model hook)
 *   key:       setupController, resetController
 *   uses:      application controller (collapses cart/menu chrome)
 *   siblings:  controllers/user.js (owns loadDataTask this route starts on entry and
 *              cancels on leave)
 *   tests:     simple-routes-test.js ("user route loads the account data and collapses
 *              the chrome")
 *   gotchas:   -
 *
 * Account page route: chrome collapse + account data load/cancel.
 */
export default class UserRoute extends Route {
  setupController(controller, model) {
    super.setupController(controller, model);
    var application = this.controllerFor('application');
    set(application, 'showCart', null);
    set(application, 'showMenu', null);
    controller.loadDataTask.perform();
  }

  resetController(controller) {
    controller.loadDataTask.cancelAll();
  }
}
